import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import NotificationQueueTable from "./Componates/NotificationQueueTable";

const NotificationQueueList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                    <HeadingOne>Notification Queue</HeadingOne>
            }
        >
            <div className="col-12">
                <NotificationQueueTable />
            </div>
        </PageBody>
    );
};

export default NotificationQueueList;
